import type { Catalogue } from "../i18n";

export const SCO: Catalogue = {
  "failed": "failed",
  "saving": "saving",
  "waiting": "waiting",
  "today": "the day",
  "yesterday": "yestreen",
  "{days}d": "{days}d",
  "{weeks}w": "{weeks}w",
  "unlabeled": "unlabeled",
  "untagged": "untagged",
  "loading more": "loading mair",
  "that's all {count}": "that's all {count}",
  "shuffled": "shuffled",
  "nothing to show": "naething tae show",
  "chi is looking again": "chi is looking again",
  "chi is looking at this one next": "chi is looking at this one next",
  "could not index that ref": "couldnae index that ref",
  "details": "details",
  "clips are not described, write your own": "clips are nae described, write yer ain",
  "chi left this one ({reason}), write your own": "chi left this one ({reason}), write yer ain",
  "chi is looking at this…": "chi's keekin' at this…",
  "not described yet, write your own or tap spark": "nae described yet, write yer ain or tap spark",
  "saved": "saved",
  "could not save the description": "couldnae save the description",
  "chi skips clips": "chi skips clips",
  "described": "described",
  "chi is looking": "chi's keekin'",
  "skipped": "skipped",
  "waiting on chi": "waiting on chi",
  "tagging {done}/{total} · {left} left": "tagging {done}/{total} · {left} left",
  "tagged {done}/{total} · {left} left": "tagged {done}/{total} · {left} left",
  "all {total} tagged": "all {total} tagged",
  "{shown} of {total}": "{shown} o' {total}",
  "{count} adding": "{count} adding",
  "{count} failed": "{count} failed",
  "{count} to describe": "{count} tae describe",
  "busy": "thrang",
  "tag": "tag",
  "tap + to add pictures, drop files here, or use + ref in chrome": "tap + tae add pictures, drop files here, or use + ref in chrome",
  "every ref already has your note": "every ref already has yer note",
  "nothing matches": "naething matches",
  "could not load references": "couldnae load references",
  "video": "video",
  "all described": "all described",
  "could not read that file": "couldnae read that file",
  "nothing usable there": "naething usable there",
  "adding {count}": "adding {count}",
  "could not import that file": "couldnae import that file",
  "showing {tag}": "showing {tag}",
  "chi is tagging {count} refs": "chi is tagging {count} refs",
  "every ref is tagged": "every ref is tagged",
  "could not start tagging": "couldnae start tagging",
  "delete this reference?": "delete this reference?",
  "ref saved": "ref saved",
  "ref save failed": "ref save failed",
  "tagging done": "tagging done",
  "mode": "mode",
  "tools": "tools",
  "Tools": "Tools",
  "Talk to Chi": "Blether wi' Chi",
  "mode tuner, drag or tap a station": "mode tuner, drag or tap a station",
  "Tool": "Tool",
  "Chi · direct line": "Chi · direct line",
  "{name}'s {what} · read only": "{name}'s {what} · read only",
  "could not open a print sheet": "couldnae open a print sheet",
  "never": "never",
  "could not shrink that picture": "couldnae shrink that picture",
  "could not read that picture": "couldnae read that picture",
  "chix is processing": "chix is processing",
  "What should I work on next?": "Whit should I work on next?",
  "nothing yet": "naething yet",
  "where it came from": "whaur it came from",
  "rent, phone…": "rent, phone…",
  "what was it": "whit was it",
  "mine": "mine",
  "{name}'s": "{name}'s",
  "added to {name}'s budget": "added tae {name}'s budget",
  "added to your budget": "added tae yer budget",
  "couldn't add that": "couldnae add that",
  "login with discord": "login wi' discord",
  "minipi #{id}": "minipi #{id}",
  "a minipi": "a minipi",
  "{who} says": "{who} says",
  "{who} · art tip": "{who} · art tip",
  "pings": "pings",
  "Late shift, {name}.": "Late shift, {name}.",
  "Morning, {name}.": "Guid mornin', {name}.",
  "Ready when you are, {name}.": "Ready when ye are, {name}.",
  "Evening, {name}.": "Guid evenin', {name}.",
  "signal": "signal",
  "sweet": "sweet",
  "edge": "edge",
  "dark fog, film grain and chi's cyan": "dark fog, film grain and chi's cyan",
  "pale daytime fog, ink and deep teal": "pale daytime fog, ink and deep teal",
  "silent hill ash and an orange coal": "silent hill ash and an orange coal",
  "deep water, teal fog, a sonar ping": "deep water, teal fog, a sonar ping",
  "rose paper and a hot pink signal": "rose paper and a hot pink signal",
  "peach cream and a coral signal": "peach cream and a coral signal",
  "mint milk with strawberry pink": "mint milk wi' strawberry pink",
  "magical girl night, violet fog, bubblegum pink": "magical lass night, violet fog, bubblegum pink",
  "midnight sky in periwinkle and pink": "midnight sky in periwinkle and pink",
  "the otherworld: rust black and blood red": "the otherworld: rust black and blood red",
  "night city chrome, warning yellow, red glitch": "night city chrome, warning yellow, red glitch",
  "bruise purple fog and acid lime": "bruise purple fog and acid lime",
  "pure black and white, no mercy": "pure black and white, nae mercy",
  "green crt, memory card manager at 2am": "green crt, memory card manager at 2am",
  "amber crt terminal, warm glow": "amber crt terminal, warm glow",
  "cream sketch paper and flipnote orange": "cream sketch paper and flipnote orange",
  "grey console, blue memory card screen": "grey console, blue memory card screen",
  "four shades of handheld green": "four shades o' handheld green",
  "none": "none",
  "scanlines": "scanlines",
  "grid": "grid",
  "dots": "dots",
  "notebook": "notebook",
  "checker": "checker",
  "crosshair": "crosshair",
  "sparkles": "sparkles",
  "hazard": "hazard",
  "starry sky": "starry lift",
  "falling leaves": "falling leaves",
  "sakura petals": "sakura petals",
  "snow": "snaw",
  "rain": "rain",
  "fireflies": "fireflies",
  "moves gently, stays still with calm motion": "moves gently, stays still wi' calm motion",
  "pattern on": "pattern on",
  "theme on": "theme on",
  "saved, type to replace": "saved, type tae replace",
  "not set": "nae set",
  "token copied": "token copied",
  "make a new extension token? the old one stops working until you paste the new one in": "make a new extension token? the auld one stops working until ye paste the new one in",
  "new token made": "new token made",
  "log out of chix on every device?": "log oot o' chix on every device?",
  "$ dollar": "$ dollar",
  "£ pound": "£ pound",
  "C$ canadian": "C$ canadian",
  "A$ australian": "A$ australian",
  "CHF swiss franc": "CHF swiss franc",
  "talking to plane": "blethering wi' plane",
  "connected to {workspace}, now pick your boards": "connected tae {workspace}, noo pick yer boards",
  "open plane": "open plane",
  "in safari, create an api token in profile settings, paste it below, then save": "in safari, create an api token in profile settings, paste it below, then save",
  "couldn't do that": "couldnae do that",
  "google turned the map key away. check it's allowed on this site and maps javascript api is on": "google turned the map key away. check it's allowed on this site and maps javascript api is on",
  "the map needs a key to draw, searches and routes still work below": "the map needs a key tae draw, searches and routes still work below",
  "the map couldn't load. searches and routes still work below": "the map couldnae load. searches and routes still work below",
  "you": "ye",
  "new pin": "new pin",
  "open now": "open noo",
  "closed now": "closed noo",
  "new": "new",
  "{rating} from 1 review": "{rating} from 1 review",
  "{rating} from {count} reviews": "{rating} from {count} reviews",
  "no reviews yet": "nae reviews yet",
  "no parking info": "nae parking info",
  "no parking listed": "nae parking listed",
  "{place} is stop {letter}": "{place} is stop {letter}",
  "save": "save",
  "looking…": "looking…",
  "nothing found there. try further out or other words": "naething found there. try further oot or ither words",
  "pick something to look for, or search above": "pick something tae look for, or search above",
  "{what} within {distance} of {place}": "{what} within {distance} o' {place}",
  "around {place}": "aroond {place}",
  "ten stops is the most": "ten stops is the maist",
  "taken out of saved": "taken oot o' saved",
  "remove {name}?": "remove {name}?",
  "nothing saved yet": "naething saved yet",
  "tap the map": "tap the map",
  "drop a pin": "drop a pin",
  "edit {name}": "edit {name}",
  "save pin": "save pin",
  "my pin": "my pin",
  "pinned": "pinned",
  "places, ratings, parking and routes come from google maps. it needs a key from your google cloud account, google gives a free allowance each month": "places, ratings, parking and routes come from google maps. it needs a key from yer google cloud account, google gives a free allowance each month",
  "fractal hasn't added a google maps key yet, so the map can't look anything up": "fractal hasnae added a google maps key yet, so the map cannae look anything up",
  "within {distance}": "within {distance}",
  "this area": "this area",
  "couldn't find where you are, staying around {place}": "couldnae find whaur ye are, staying aroond {place}",
  "cyan": "cyan",
  "violet": "violet",
  "amber": "amber",
  "green": "green",
  "red": "red",
  "tap the map where the pin goes": "tap the map whaur the pin goes",
  "couldn't find where you are": "couldnae find whaur ye are",
  "take this pin off the map?": "take this pin off the map?",
  "where i am": "whaur i am",
  "home ({place})": "hame ({place})",
  "name this route": "name this route",
  "{from} to {to}": "{from} tae {to}",
  "route saved": "route saved",
  "food": "scran",
  "pubs and bars": "pubs and bars",
  "takeaway": "cairry-oot",
  "shops": "shops",
  "fuel": "fuel",
  "parking": "parking",
  "pharmacy": "pharmacy",
  "parks": "parks",
  "things to see": "things tae see",
  "cinema": "cinema",
  "ev charging": "ev charging",
  "drive": "drive",
  "walk": "walk",
  "cycle": "cycle",
  "bus/train": "bus/train",
  "{amount} a month": "{amount} a month",
  "by {date}": "by {date}",
  "monthly, stopped {date}": "monthly, stopped {date}",
  "monthly from {date}": "monthly from {date}",
  "on {date}": "on {date}",
  "added by you": "added by ye",
  "added by {name}": "added by {name}",
  "{done} paid of {total} · {left} left": "{done} paid o' {total} · {left} left",
  "paid off · {total}": "paid off · {total}",
  "{done} saved of {total} · {left} to go": "{done} saved o' {total} · {left} tae go",
  "reached · {done}": "reached · {done}",
  "in": "in",
  "bill": "bill",
  "cost": "cost",
  "debt": "debt",
  "goal": "goal",
  "remove {name}? its history goes too": "remove {name}? its history goes too",
  "restart": "restart",
  "stop": "stop",
  "paid": "paid",
  "payment logged": "payment logged",
  "saved toward it": "saved toward it",
  "took back the last one": "took back the last one",
  "{amount} left": "{amount} left",
  "{amount} saved": "{amount} saved",
  "out": "oot",
  "no monthly bills yet": "nae monthly bills yet",
  "owe": "owe",
  "{percent}% of {total}": "{percent}% o' {total}",
  "{amount} this month": "{amount} this month",
  "owed in total": "owed in total",
  "target": "target",
  "a month (optional)": "a month (optional)",
  "how much comes in": "hoo much comes in",
  "how much": "hoo much",
  "by": "by",
  "since": "since",
  "from": "from",
  "on": "on",
  "where it comes from": "whaur it comes from",
  "rent, phone, adobe…": "rent, phone, adobe…",
  "what you bought": "whit ye bought",
  "who or what you owe": "wha or whit ye owe",
  "what you're saving for": "whit ye're saving for",
  "add": "add",
  "add to the budget": "add tae the budget",
  "added": "added",
  "couldn't save that": "couldnae save that",
  "due: {title}": "due: {title}",
  "unexpected \"{char}\"": "unexpected \"{char}\"",
  "missing )": "missing )",
  "expected a number": "expected a number",
  "that goes to infinity": "that goes tae infinity",
  "not set, add it in setup": "nae set, add it in setup",
  "{spent} of {budget} for tagging": "{spent} o' {budget} for tagging",
  "no cap on tagging": "nae cap on tagging",
  "{count} refs waiting since {time}": "{count} refs waiting since {time}",
  "none running": "none running",
  "{calls} calls · {input} in · {cached} cached · {output} out": "{calls} calls · {input} in · {cached} cached · {output} oot",
  "nothing yet for {month}": "naething yet for {month}",
  "{calls} calls": "{calls} calls",
  "split starts with the next answer": "split starts wi' the next answer",
  "could not read claude usage": "couldnae read claude usage",
  "all": "all",
  "start {name}?": "start {name}?",
  "starting {name}...": "starting {name}...",
  "{name} start sent": "{name} start sent",
  "stop {name}?": "stop {name}?",
  "stopping {name}...": "stopping {name}...",
  "{name} stop sent": "{name} stop sent",
  "restart {name}?": "restart {name}?",
  "restarting {name}...": "restarting {name}...",
  "{name} restart sent": "{name} restart sent",
  "running": "running",
  "stopped": "stopped",
  "crash looping": "fankled in a loop",
  "starting": "starting",
  "up {time}": "up {time}",
  "{count} restarts": "{count} restarts",
  "{name} logs": "{name} logs",
  "loading...": "loading...",
  "{used} of {total}": "{used} o' {total}",
  "could not reach the server: {error}": "couldnae reach the server: {error}",
  "validating caddy...": "validating caddy...",
  "caddy reloaded": "caddy reloaded",
  "{label}, one per line": "{label}, one per line",
  "change picture": "change picture",
  "all {n}": "all {n}",
  "unsorted": "unsorted",
  "under a cent": "under a cent",
  "chi looking {done}/{total}": "chi looking {done}/{total}",
  "chi look {done}/{total}": "chi look {done}/{total}",
  "chi looked": "chi looked",
  "chi has looked at every character picture": "chi has looked at every character picture",
  "{n} more wait for another press.": "{n} mair wait for anither press.",
  "chi has looked at {done} of {total} character pictures. look at the next {count} for about {price}? it goes through the half price batch, so it can take a while.": "chi has looked at {done} o' {total} character pictures. look at the next {count} for aboot {price}? it goes through the half price batch, so it can take a wee while.",
  "chi is looking at {count} pictures": "chi is looking at {count} pictures",
  "could not start chi": "couldnae start chi",
  "chi looks at 1 picture of {name} she hasn't seen, about {price}?": "chi looks at 1 picture o' {name} she hasnae seen, aboot {price}?",
  "chi looks at {count} pictures of {name} she hasn't seen, about {price}?": "chi looks at {count} pictures o' {name} she hasnae seen, aboot {price}?",
  "chi has seen all {total} pictures of {name}. look at them again from scratch, about {price}?": "chi has seen all {total} pictures o' {name}. look at them again from scratch, aboot {price}?",
  "chi is looking at {name}": "chi is looking at {name}",
  "picture {n}": "picture {n}",
  "adding 1 picture…": "adding 1 picture…",
  "adding {n} pictures…": "adding {n} pictures…",
  "picture added": "picture added",
  "{n} pictures added": "{n} pictures added",
  "could not add the picture": "couldnae add the picture",
  "take this picture off the character?": "take this picture off the character?",
  "picture removed": "picture removed",
  "could not remove the picture": "couldnae remove the picture",
  "sheet picture changed": "sheet picture changed",
  "could not change the picture": "couldnae change the picture",
  "fetching characters from {source}…": "fetching characters from {source}…",
  "{n} found": "{n} found",
  "{n} added": "{n} added",
  "{n} updated": "{n} updated",
  "{n} duplicates merged": "{n} duplicates merged",
  "{n} failed": "{n} failed",
  "{source} import failed": "{source} import failed",
  "aka {names}": "aka {names}",
  "{n} pictures": "{n} pictures",
  "merge into {name}": "merge into {name}",
  "merge {other} into {name}? {other}'s sheet goes away and its pictures move to {name}.": "merge {other} into {name}? {other}'s sheet goes away and its pictures move tae {name}.",
  "{other} merged into {name}": "{other} merged into {name}",
  "the sheet": "the sheet",
  "could not merge": "couldnae merge",
  "character saved": "character saved",
  "could not save": "couldnae save",
  "delete {name}?": "delete {name}?",
  "1 block today": "1 block the day",
  "{n} blocks today": "{n} blocks the day",
  "resume": "resume",
  "back to drawing": "back tae drawing",
  "break time, stretch your hand": "break time, stretch yer hand",
  "focus block started": "focus block started",
  "take a break": "take a break",
  "type minutes, like 40 or 1h30": "type minutes, like 40 or 1h30",
  "drop this picture": "drop this picture",
  "toss {hex}?": "toss {hex}?",
  "copied {hex}": "copied {hex}",
  "prompt copied": "prompt copied",
  "commissions": "commissions",
  "no commissions": "nae commissions",
  "comms money": "comms money",
  "{n} paid": "{n} paid",
  "{n} others": "{n} ithers",
  "nothing paid yet": "naething paid yet",
  "that task is done or gone": "that task is done or gone",
  "unlink {title}": "unlink {title}",
  "no task matches": "nae task matches",
  "no open tasks. add one in tasks first": "nae open tasks. add one in tasks first",
  "for {client}": "for {client}",
  "paid {day}": "paid {day}",
  "due {date}": "due {date}",
  "commission saved": "commission saved",
  "commission added": "commission added",
  "break": "break",
  "unknown": "unkent",
  "fapped {n} times": "fapped {n} times",
  "no doodles match": "nae doodles match",
  "could not load the doodles": "couldnae load the doodles",
  "no picture on the clipboard": "nae picture on the clipboard",
  "pick a picture": "pick a picture",
  "you can look at the doodles, not add them": "ye can look at the doodles, nae add them",
  "adding the doodle": "adding the doodle",
  "adding {n} of {total}": "adding {n} o' {total}",
  "{n} doodles added": "{n} doodles added",
  "could not add that": "couldnae add that",
  "press ctrl+v or ⌘v to paste": "press ctrl+v or ⌘v tae paste",
  "couldn't read the clipboard, try ctrl+v or ⌘v": "couldnae read the clipboard, try ctrl+v or ⌘v",
  "gone": "awa",
  "remove {name}": "remove {name}",
  "new doodle": "new doodle",
  "doodle saved": "doodle saved",
  "delete this doodle?": "delete this doodle?",
  "could not delete": "couldnae delete",
  "by {name}": "by {name}",
  "one a day per doodle, come back tomorrow": "one a day per doodle, come back the morn",
  "today ✓ {n}": "the day ✓ {n}",
  "fapped {n}×": "fapped {n}×",
  "you {n}": "ye {n}",
  "could not count that": "couldnae count that",
  "random full body poses from the pocketbase library": "random full body poses from the pocketbase library",
  "{n} refs in the pool": "{n} refs in the pool",
  "no refs match yet": "nae refs match yet",
  "could not fetch poses": "couldnae fetch poses",
  "play": "play",
  "no poses to draw from": "nae poses tae draw from",
  "{n} poses done, nice": "{n} poses done, braw",
  "{n} answered today": "{n} answered the day",
  "{n} day streak": "{n} day streak",
  "nothing due right now, {n} learning cards come back in {minutes}m": "naething due richt noo, {n} learning cards come back in {minutes}m",
  "today's cards are done, see you tomorrow": "the day's cards are done, see ye the morn",
  "no cards to study, switch a deck on below": "nae cards tae study, switch a deck on below",
  "{seen} of {total} seen · {solid} solid": "{seen} o' {total} seen · {solid} solid",
  "study {deck}": "study {deck}",
  "could not load the deck": "couldnae load the deck",
  "could not save that answer": "couldnae save that answer",
  "could not save the deck setup": "couldnae save the deck setup",
  "basics": "basics",
  "favourites": "favourites",
  "likes and goals": "likes and goals",
  "looks": "looks",
  "identity": "identity",
  "sexuality": "sexuality",
  "story": "story",
  "for chi": "for chi",
  "orientation": "orientation",
  "trivia": "trivia",
  "created by": "created by",
  "world": "world",
  "location": "location",
  "race": "race",
  "occupation": "occupation",
  "gender": "gender",
  "height": "height",
  "favourite food": "favourite food",
  "smell": "smell",
  "pet peeve": "pet peeve",
  "likes": "likes",
  "dislikes": "dislikes",
  "look in short": "look in short",
  "body": "body",
  "clothes": "clothes",
  "visual features": "visual features",
  "speaking": "speaking",
  "personality": "personality",
  "relationships": "relationships",
  "items": "items",
  "skills": "skills",
  "preferences": "preferences",
  "fetishes": "fetishes",
  "sexual trivia": "sexual trivia",
  "rpg sheet": "rpg sheet",
  "fractal's notes for chi": "fractal's notes for chi",
  "sees your {kinds}": "sees yer {kinds}",
  "sees nothing of yours": "sees naething o' yers",
  "{line}, adds to your {kinds}": "{line}, adds tae yer {kinds}",
  "{name} can add to your {kind}": "{name} can add tae yer {kind}",
  "{name} can only read your {kind}": "{name} can only read yer {kind}",
  "{name} can see your {kind}": "{name} can see yer {kind}",
  "{kind} hidden from {name}": "{kind} hidden from {name}",
  "{name} can see everything you can share": "{name} can see everything ye can share",
  "{name} sees nothing of yours now": "{name} sees naething o' yers noo",
  "share {kind} with {name}": "share {kind} wi' {name}",
  "you don't have notes, pings or anything else to share yet": "ye dinnae have notes, pings or anything else tae share yet",
  "share all": "share all",
  "share none": "share none",
  "nobody else is in chix yet": "naebody else is in chix yet",
  "shares their {kinds}": "shares their {kinds}",
  "Calendar events": "Calendar events",
  "Places and routes": "Places and routes",
  "your sticky notes": "yer sticky notes",
  "reminders, alarms and timers": "reminders, alarms and timers",
  "your own events on the month": "yer ain events on the month",
  "plane and chix bot": "plane and chix bot",
  "clients, prices, status, linked tasks and money stats": "clients, prices, status, linked tasks and money stats",
  "bills, costs, debts and goals": "bills, costs, debts and goals",
  "what you keep up and your streaks": "whit ye keep up and yer streaks",
  "spots and routes you saved on the map": "spots and routes ye saved on the map",
  "Can add to it": "Can add tae it",
  "bills, costs, money in and payments, with their name on them. they can change only what they added": "bills, costs, money in and payments, wi' their name on them. they can change only whit they added",
  "off": "off",
  "{on} of {total} on · chi {spent} of {cap}": "{on} o' {total} on · chi {spent} o' {cap}",
  "{on} of {total} on · chi {spent}": "{on} o' {total} on · chi {spent}",
  "{feature} off for {name}": "{feature} off for {name}",
  "{name} can view {feature}": "{name} can view {feature}",
  "{name} can edit {feature}": "{name} can edit {feature}",
  "{feature} for {name}": "{feature} for {name}",
  "monthly chi cap, usd": "monthly chi cap, usd",
  "{name}'s chi stops at {amount} a month": "{name}'s chi stops at {amount} a month",
  "no cap for {name}": "nae cap for {name}",
  "{spent} over {count} answers this month. 0 means no cap": "{spent} over {count} answers this month. 0 means nae cap",
  "remove {name}? they get signed out. their own notes and chats stay on the server if you add them back": "remove {name}? they get signed oot. their ain notes and chats stay on the server if ye add them back",
  "{name} removed": "{name} removed",
  "just you for now": "jist yersel for noo",
  "{name} can sign in now. they start with chi, notes, pings and routines": "{name} can sign in noo. they start wi' chi, notes, pings and routines",
  "Calendar and pings": "Calendar and pings",
  "Chi speaker": "Chi speaker",
  "Discord messages": "Discord messages",
  "Keys and server setup": "Keys and server setup",
  "their own chat and memory, on your claude account": "their ain chat and memory, on yer claude account",
  "the shared ref library": "the shared ref library",
  "the shared oc sheets": "the shared oc sheets",
  "their own": "their ain",
  "plane and chix bot, their own": "plane and chix bot, their ain",
  "timer, palette, prompts, comms and their money stats": "timer, palette, prompts, comms and their money stats",
  "their own bills, costs, debts and goals": "their ain bills, costs, debts and goals",
  "places nearby, routes and their saved spots, on your google maps key": "places nearby, routes and their saved spots, on yer google maps key",
  "gesture drawing and japanese": "gesture drawing and japanese",
  "the shared doodle wall": "the shared doodle wall",
  "their own scan library": "their ain scan library",
  "their pings ring at home, chi answers their voice": "their pings ring at home, chi answers their voice",
  "chi can dm your contacts for them": "chi can dm yer contacts for them",
  "vps panel and bot controls": "vps panel and bot controls",
  "every log line": "every log line",
  "spend and billing": "spend and billing",
  "api keys, ssh": "api keys, ssh",
  "this dashboard": "this dashboard",
  "tap to upload": "tap tae upload",
  "{count} kept": "{count} kept",
  "uploading {n} of {total}": "uploading {n} o' {total}",
  "scan kept": "scan kept",
  "{count} scans kept": "{count} scans kept",
  "upload failed": "upload failed",
  "the brother is scanning": "the brother is scanning",
  "scan failed": "scan failed",
  "saving {n} of {total}": "saving {n} o' {total}",
  "added to scans": "added tae scans",
  "could not save that": "couldnae save that",
  "pdf scan, use download to open it": "pdf scan, use download tae open it",
  "delete this scan?": "delete this scan?",
  "days apart": "days apart",
  "times a week, any days": "times a week, any days",
  "day of the month": "day o' the month",
  "added by another part of chix, ticked off there too": "added by anither part o' chix, ticked off there too",
  "delete {title} and its history?": "delete {title} and its history?",
  "no routines": "nae routines",
  "ChiX routine": "ChiX routine",
  "time for {title}": "time for {title}",
  "weekdays": "weekdays",
  "every {n} days": "every {n} days",
  "{n}x a week": "{n}x a week",
  "monthly on day {day}": "monthly on day {day}",
  "{done}/{times} this week": "{done}/{times} this week",
  "ping {time}": "ping {time}",
  "{n}w streak": "{n}w streak",
  "{n} streak": "{n} streak",
  "{title} done": "{title} done",
  "sticky {date}": "sticky {date}",
  "saved {time}": "saved {time}",
  "nothing coming up": "naething coming up",
  "edit chix task": "edit chix task",
  "new chix task": "new chix task",
  "saving...": "saving...",
  "mark \"{title}\" as done?": "mark \"{title}\" as done?",
  "urgent": "urgent",
  "high": "high",
  "medium": "medium",
  "low": "low",
  "{count} shown, updated {time}": "{count} shown, updated {time}",
  "nothing pending": "naething pending",
  "night": "night",
  "fog": "fog",
  "ember": "ember",
  "abyss": "abyss",
  "petal": "petal",
  "peach": "peach",
  "mint": "mint",
  "lilac": "lilac",
  "starlight": "starlight",
  "venom": "venom",
  "pocket": "pocket",
  "{title} reached, tap done to cross it off": "{title} reached, tap done tae cross it off",
  "delete {title}? it won't come back": "delete {title}? it willnae come back",
  "done · {n}": "done · {n}",
  "no goals": "nae goals",
  "this one's done, saving keeps it crossed out": "this one's done, saving keeps it crossed oot",
  "no goals on the go": "nae goals on the go",
  "add a couple of options": "add a couple o' options",
  "last one standing: {label}": "last one standing: {label}",
  "everything's been knocked out": "everything's been knocked oot",
  "spinning": "spinning",
  "the wheel says": "the wheel says",
  "new wheel": "new wheel",
  "knocked out": "knocked oot",
  "{n} on the wheel, {out} knocked out": "{n} on the wheel, {out} knocked oot",
  "{n} on the wheel": "{n} on the wheel",
  "just now": "jist noo",
  "{n}m ago": "{n}m ago",
  "{n}h ago": "{n}h ago",
  "ready": "ready",
  "flick the wheel or press spin": "flick the wheel or press spin",
  "add a couple of options to spin": "add a couple o' options tae spin",
  "a wheel holds {max} options": "a wheel holds {max} options",
  "only {room} fit, a wheel holds {max}": "only {room} fit, a wheel holds {max}",
  "my characters": "my characters",
  "there aren't enough characters yet": "there arenae enough characters yet",
  "which oc": "which oc",
  "{name} copy": "{name} copy",
  "delete the wheel \"{name}\"?": "delete the wheel \"{name}\"?",
  "yes or no": "aye or naw",
  "what to draw": "whit tae draw",
  "dinner": "tea",
  "dice": "dice",
  "who does it": "wha does it",
  "yes": "aye",
  "gesture warm up": "gesture warm up",
  "portrait": "portrait",
  "an oc": "an oc",
  "hands and feet": "hands and feet",
  "background": "background",
  "comic page": "comic page",
  "redraw an old piece": "redraw an auld piece",
  "burgers": "burgers",
  "noodles": "noodles",
  "cook something": "cook some scran",
  "yellow": "yellow",
  "orange": "orange",
  "lime": "lime",
  "teal": "teal",
  "blue": "blue",
  "purple": "purple",
  "pink": "pink",
  "white": "white",
  "black": "black",
  "sky": "lift",
  "slate": "slate",
  "edit message": "edit message",
  "delete your message? it goes for everyone": "delete yer message? it goes for everyone",
  "delete {name}'s message? it goes for everyone": "delete {name}'s message? it goes for everyone",
  "couldn't delete that": "couldnae delete that",
  "couldn't post that": "couldnae post that",
  "1 message": "1 message",
  "{n} messages": "{n} messages",
  "someone": "somebody",
  "edited": "edited",
  "now": "noo",
  "{n}m": "{n}m",
  "{n}h": "{n}h",
  "+{n} more": "+{n} mair",
  "couldn't switch": "couldnae switch",
  "switch": "switch",
  "profile": "profile",
  "that isn't a picture": "that isnae a picture",
  "picture saved": "picture saved",
  "upload picture": "upload picture",
  "use {name}'s discord picture": "use {name}'s discord picture",
  "remove picture": "remove picture",
  "owned by": "owned by",
  "remove {name} as an owner": "remove {name} as an owner",
  "owner removed": "owner removed",
  "another discord user id": "anither discord user id",
  "discord user id": "discord user id",
  "add owner": "add owner",
  "they can sign in as {name} now": "they can sign in as {name} noo",
  "a discord account that owns an alter can sign in and switch to it, so give the alter's own account here": "a discord account that owns an alter can sign in and switch tae it, so give the alter's ain account here",
  "she/her, they/them…": "she/her, they/them…",
  "a line about them": "a line aboot them",
  "pronouns": "pronouns",
  "about": "aboot",
  "be {name}": "be {name}",
  "{name} is part of {system}": "{name} is part o' {system}",
  "back to my profile": "back tae my profile",
  "remove {name}? their notes and chats stay on the server if you add them back": "remove {name}? their notes and chats stay on the server if ye add them back",
  "no alters yet. add the first one above": "nae alters yet. add the first one above",
  "{name} added": "{name} added",
  "size: {size}, change": "size: {size}, change",
  "small": "wee",
  "half": "half",
  "wide": "wide",
  "hide": "hide",
  "move earlier": "move earlier",
  "move later": "move later",
  "hold to drag": "hold tae drag",
  "arrange home": "arrange home",
  "ask chi": "ask chi",
  "inbox": "inbox",
  "gauges": "gauges",
  "message board": "message board",
  "spin": "spin",
  "{n} lines": "{n} lines",
  "live": "live",
  "no shared boards yet. make one and everyone can draw on it together": "nae shared boards yet. make one and everyone can draw on it together",
  "no shared boards yet. Fractal can make one": "nae shared boards yet. Fractal can make one",
  "{shared} shared · {mine} yours": "{shared} shared · {mine} yers",
  "could not load the boards": "couldnae load the boards",
  "could not make a board": "couldnae make a board",
  "that board was deleted": "that board was deleted",
  "shared board": "shared board",
  "board": "board",
  "offline, will send when back": "offline, will send when back",
  "that's someone else's, only they can change it": "that's somebody else's, only they can change it",
  "lost the board": "lost the board",
  "that layer is hidden, show it to draw": "that layer is hidden, show it tae draw",
  "that layer is hidden, show it to write": "that layer is hidden, show it tae write",
  "that layer is locked": "that layer is locked",
  "that layer is {who}'s, ask them to let you draw on it": "that layer is {who}'s, ask them tae let ye draw on it",
  "that layer has other people's lines, use the stroke eraser": "that layer has ither people's lines, use the stroke eraser",
  "pencil found, fingers now move the board": "pencil found, fingers noo move the board",
  "{n} frames": "{n} frames",
  "open": "open",
  "empty": "empty",
  "this layer is yours": "this layer is yers",
  "{who}'s layer": "{who}'s layer",
  ", open to everyone": ", open tae everyone",
  ", only they draw here": ", only they draw here",
  "frames": "frames",
  "animate": "animate",
  "layer {n}": "layer {n}",
  "delete {name}? you can undo it": "delete {name}? ye can undo it",
  "{name} cleared, undo brings it back": "{name} cleared, undo brings it back",
  "{n} frames is the most a layer holds": "{n} frames is the maist a layer holds",
  "delete frame {n}? you can undo it": "delete frame {n}? ye can undo it",
  "frame {n}": "frame {n}",
  "frames per second": "frames per second",
  "onion skin {state}": "onion skin {state}",
  "shared · look only": "shared · look only",
  "shared · live": "shared · live",
  "private": "private",
  "paper {color}": "paper {color}",
  "could not make the picture": "couldnae make the picture",
  "draw something first": "draw something first",
  "posted to the doodle wall": "posted tae the doodle wall",
  "could not post it": "couldnae post it",
  "delete {name}? this can't be undone": "delete {name}? this cannae be undone",
  "delete {name}? this can't be undone, and it goes for everyone": "delete {name}? this cannae be undone, and it goes for everyone",
  "could not delete it": "couldnae delete it",
  "could not open that board": "couldnae open that board",
  "brush": "brush",
  "erase": "erase",
  "select": "select",
  "shape": "shape",
  "text": "text",
  "move": "move",
  "line": "line",
  "arrow": "arrow",
  "box": "box",
  "ellipse": "ellipse",
  "rub out": "rub oot",
  "whole strokes": "whole strokes",
  "duplicate": "duplicate",
  "delete": "delete",
  "done": "done",
  "drag to pick, tap one stroke": "drag tae pick, tap one stroke",
  "show": "show",
  "lock": "lock",
  "unlock": "unlock",
  "move up": "move up",
  "move down": "move doon",
  "stop playing": "wheesht",
  "play this layer": "play this layer",
  "previous frame": "previous frame",
  "next frame": "next frame",
  "new empty frame": "new empty frame",
  "copy this frame": "copy this frame",
  "delete this frame": "delete this frame",
  "move this frame earlier": "move this frame earlier",
  "move this frame later": "move this frame later",
  "plain": "plain",
  "lines": "lines",
  "pen": "pen",
  "pencil": "pencil",
  "ink": "ink",
  "marker": "marker",
  "glow": "glow",
  "eraser": "eraser",
  "water": "water",
  "air": "air",
  "spray": "spray",
  "coal": "coal",
  "chalk": "chalk",
  "crayon": "crayon",
  "rainbow": "rainbow",
  "glitter": "glitter",
  "neon": "neon",
  "boil": "boil",
  "wave": "wave",
  "flame": "flame",
  "march": "march",
  "pulse": "pulse",
  "draw": "draw",
  "paint": "paint",
  "texture": "texture",
  "steady": "steady",
  "pressure": "pressure",
  "soft": "soft",
  "spread": "spread",
  "reset this brush": "reset this brush",
  "multiply": "multiply",
  "screen": "screen",
  "overlay": "overlay",
  "soft light": "soft light",
  "hard light": "hard light",
  "darken": "darken",
  "lighten": "lighten",
  "color dodge": "color dodge",
  "color burn": "color burn",
  "difference": "difference",
  "exclusion": "exclusion",
  "Goals": "Goals",
  "me": "me",
  "Profile": "Profile",
  "Message board": "Message board",
  "Roulette": "Roulette",
  "Whiteboards": "Whiteboards",
  "nothing on the board yet": "naething on the board yet",
  "add to a": "add tae a",
  "default": "default",
  "out of": "oot o'",
  "no goals yet. add one for a chapter to finish, a page count to hit or anything you're working towards": "nae goals yet. add one for a chapter tae finish, a page count tae hit or anything ye're working towards",
  "kana is the standard gojūon table. kanji are the 2,211 jlpt n5 to n1 kanji, meanings and readings from kanjidic2 (edrdg, cc by-sa 4.0), levels from jonathan waller's jlpt lists (cc by)": "kana is the standard gojūon table. kanji are the 2,211 jlpt n5 tae n1 kanji, meanings and readings from kanjidic2 (edrdg, cc by-sa 4.0), levels from jonathan waller's jlpt lists (cc by)",
  "bring all back": "bring all back",
  "slices": "slices",
  "history": "history",
  "options": "options",
  "pasting a list adds them all. pizza *3 makes pizza three times as likely, and the weights below set it per slice": "pasting a list adds them all. pizza *3 makes pizza three times as likely, and the weights below set it per slice",
  "no options yet. add a few, or start from a preset in options": "nae options yet. add a few, or start from a preset in options",
  "shuffle": "shuffle",
  "even odds": "even odds",
  "theme colours": "theme colours",
  "tally": "tally",
  "last spins": "last spins",
  "nothing spun on this wheel yet": "naething spun on this wheel yet",
  "after a spin": "efter a spin",
  "keep it": "keep it",
  "knock it out": "knock it oot",
  "knock it out takes each winner off the wheel until you bring them all back, good for turns and tournaments": "knock it oot takes each winner off the wheel until ye bring them all back, good for turns and tournaments",
  "spin length": "spin length",
  "quick": "quick",
  "clicks and a jingle": "clicks and a jingle",
  "new wheel from": "new wheel from",
  "copy this wheel": "copy this wheel",
  "delete wheel": "delete wheel",
  "winners are picked with your device's secure random, in proportion to each slice's weight, so a slice that looks twice as big really is twice as likely": "winners are picked wi' yer device's secure random, in proportion tae each slice's weight, so a slice that looks twice as big really is twice as likely",
  "wheel": "wheel",
  "the wheel, flick it to spin": "the wheel, flick it tae spin",
  "add options, one per line": "add options, one per line",
  "option": "option",
  "weight": "weight",
  "less likely": "less likely",
  "more likely": "mair likely",
  "less": "less",
  "more": "mair",
  "shared": "shared",
  "new board": "new board",
  "mine · private": "mine · private",
  "no boards of your own yet. only you ever see these": "nae boards o' yer ain yet. only ye ever see these",
  "layers": "layers",
  "opacity": "opacity",
  "blend": "blend",
  "let others draw on this layer": "let ithers draw on this layer",
  "brush ·": "brush ·",
  "pick from the board": "pick from the board",
  "recent": "recent",
  "any colour": "any colour",
  "paper": "paper",
  "only the pencil draws, fingers move and zoom the board": "only the pencil draws, fingers move and zoom the board",
  "fit": "fit",
  "save png": "save png",
  "post to doodles": "post tae doodles",
  "two fingers pinch and move, tap two fingers to undo, three to redo. on a keyboard: space drags, [ and ] size, ⌘z undo, k brushes, x erases whole strokes, t text, v select, u shapes, comma and full stop step frames, backslash plays": "two fingers pinch and move, tap two fingers tae undo, three tae redo. on a keyboard: space drags, [ and ] size, ⌘z undo, k brushes, x erases whole strokes, t text, v select, u shapes, comma and full stop step frames, backslash plays",
  "delete board": "delete board",
  "Board": "Board",
  "everyone on chi sees this": "everyone on chi sees this",
  "nothing on the board yet. post the first line": "naething on the board yet. post the first line",
  "who's here": "wha's here",
  "who is here": "wha is here",
  "jot to inbox": "jot tae the inbox",
  "say something to everyone": "say something tae everyone",
  "message for the board": "message for the board",
  "finish the chapter 2 sprites…": "finish the chapter 2 sprites…",
  "why, or what done looks like, optional": "why, or whit done looks like, optional",
  "progress": "progress",
  "counting what": "counting whit",
  "a board everyone can draw on together": "a board everyone can draw on together",
  "a board only you can see": "a board only ye can see",
  "text on the board": "text on the board",
  "back to the boards": "back tae the boards",
  "undo, or tap with two fingers": "undo, or tap wi' two fingers",
  "redo": "redo",
  "redo, or tap with three fingers": "redo, or tap wi' three fingers",
  "fit the drawing on screen": "fit the drawing on screen",
  "fit to the drawing": "fit tae the drawing",
  "board settings": "board settings",
  "brush size": "brush size",
  "say something to everyone…": "say something tae everyone…",
  "new alter name": "new alter name",
  "all {count} presets are taken, unpin one first": "all {count} presets are taken, unpin one first",
  "could not change the owner": "couldnae change the owner",
  "description": "description",
  "groups": "groups",
  "large": "muckle",
  "layout": "layout",
  "mine {n}": "mine {n}",
  "owners": "owners",
  "presets": "presets",
  "reversed": "reversed",
  "sort by": "sort by",
  "tap the star on a key to pin it. pins sit above the dock as presets": "tap the star on a key tae pin it. pins sit above the dock as presets",
  "unknown date": "date unkent",
  "{name} is not yours any more": "{name} isnae yers any mair",
  "{name} is yours now": "{name} is yers noo",
  "Grid": "Grid",
  "Masonry": "Masonry",
  "Rows": "Rows",
  "Big grid": "Muckle grid",
  "Wall": "Wall",
  "Posts": "Posts",
  "Shuffle": "Shuffle",
  "random order, rolled once while it is open": "random order, rolled once while it is open",
  "Newest": "Newest",
  "latest saved first": "latest saved first",
  "Oldest": "Auldest",
  "earliest saved first": "earliest saved first",
  "Most tagged": "Maist tagged",
  "refs with the most tags first": "refs wi' the maist tags first",
  "Undescribed first": "Undescribed first",
  "what has no description yet comes first": "whit has nae description yet comes first",
  "By tag": "By tag",
  "grouped under the most used tag": "grouped under the maist used tag",
  "By author": "By author",
  "grouped A to Z": "grouped A tae Z",
  "By month": "By month",
  "grouped by the month you saved them": "grouped by the month ye saved them",
  "By type": "By type",
  "stills, gifs and clips apart": "stills, gifs and clips apart",
  "sign in with discord · fractal and pauline": "sign in wi' discord · fractal and pauline",
  "continue with discord": "continue wi' discord",
  "use": "use",
  "Ready when you are.": "Ready when ye are.",
  "unit": "unit",
  "chi · online": "chi · online",
  "clear": "clear",
  "tip of the day": "tip o' the day",
  "another one": "anither one",
  "add to a budget": "add tae a budget",
  "every month": "every month",
  "up next": "up next",
  "all tasks": "all tasks",
  "nothing due, go draw": "naething due, awa an' draw",
  "routines": "routines",
  "routines done for today": "routines done for the day",
  "notes": "notes",
  "no notes yet": "nae notes yet",
  "Tasks": "Tasks",
  "chix task": "chix task",
  "Notes": "Notes",
  "note": "note",
  "scratchpad": "jotter",
  "edit": "edit",
  "view": "view",
  "random": "random",
  "newest": "newest",
  "oldest": "auldest",
  "by tag": "by tag",
  "stills": "stills",
  "moving": "moving",
  "chi's description": "chi's description",
  "your note": "yer note",
  "ctrl+enter saves and goes next": "ctrl+enter saves and goes next",
  "edit tags": "edit tags",
  "close": "close",
  "next": "next",
  "Chi online. What are we drawing?": "Chi online. Whit are we drawing?",
  "what should I work on?": "whit should I work on?",
  "pose refs": "pose refs",
  "pick an oc": "pick an oc",
  "comms": "comms",
  "Routines": "Routines",
  "routine": "routine",
  "every day": "every day",
  "on these days": "on these days",
  "every few days": "every few days",
  "times a week": "times a week",
  "once a month": "once a month",
  "mon": "mon",
  "tue": "tue",
  "wed": "wed",
  "thu": "thu",
  "fri": "fri",
  "sat": "sat",
  "sun": "sun",
  "ping at": "ping at",
  "paused": "on haud",
  "cancel": "cancel",
  "nothing on today": "naething on the day",
  "other days": "ither days",
  "no routines yet. add one for a daily sketch, a weekly stream or anything you want to keep up": "nae routines yet. add one for a daily sketch, a weekly stream or anything ye want tae keep up",
  "Pings": "Pings",
  "reminder": "reminder",
  "alarm": "alarm",
  "timer": "timer",
  "once": "once",
  "daily": "daily",
  "weekly": "weekly",
  "set": "set",
  "no pings yet. set one for a stream, a deadline or a break": "nae pings yet. set one for a stream, a deadline or a break",
  "Session": "Session",
  "focus": "focus",
  "start": "start",
  "tap the time to type your own, like 40 or 1h30": "tap the time tae type yer ain, like 40 or 1h30",
  "0 blocks today": "0 blocks the day",
  "Palette": "Palette",
  "keep": "keep",
  "tap a swatch to copy it, hold to toss it": "tap a swatch tae copy it, hold tae toss it",
  "save prompt": "save prompt",
  "tap a card to copy the whole prompt": "tap a card tae copy the whole prompt",
  "Comms": "Comms",
  "tap a commission to edit it": "tap a commission tae edit it",
  "list": "list",
  "money": "money",
  "new commission": "new commission",
  "sketch": "sketch",
  "wip": "wip",
  "review": "review",
  "reference pics": "reference pics",
  "this month": "this month",
  "this year": "this year",
  "to be paid": "tae be paid",
  "paid by month": "paid by month",
  "by client": "by client",
  "by status": "by status",
  "a commission counts on the day it was marked paid. change that day on its card": "a commission counts on the day it was marked paid. change that day on its card",
  "Budget": "Budget",
  "left": "left",
  "in and out": "in and oot",
  "monthly by category": "monthly by category",
  "debts and goals": "debts and goals",
  "one off": "one off",
  "monthly": "monthly",
  "bills": "bills",
  "costs": "costs",
  "debts": "debts",
  "goals": "goals",
  "nothing here yet. add a bill, a debt or a goal above": "naething here yet. add a bill, a debt or a goal above",
  "only you see this unless you switch it on for someone in sharing. paid commissions count as money in": "only ye see this unless ye switch it on for somebody in sharing. paid commissions count as money in",
  "Gesture": "Gesture",
  "timed poses, draw fast, the next one drops in on its own": "timed poses, draw fast, the next one drops in on its ain",
  "source": "source",
  "full body": "full body",
  "my refs": "my refs",
  "each pose": "each pose",
  "pause": "haud on",
  "skip": "skip",
  "Japanese": "Japanese",
  "learning": "learning",
  "show answer": "show answer",
  "again": "again",
  "hard": "hard",
  "good": "braw",
  "easy": "easy",
  "space shows the answer, 1 to 4 grades it": "space shows the answer, 1 tae 4 grades it",
  "decks": "decks",
  "new cards a day": "new cards a day",
  "study, new cards come in this order": "study, new cards come in this order",
  "Characters": "Characters",
  "chi look": "chi look",
  "no characters match": "nae characters match",
  "new character": "new character",
  "name": "name",
  "tags, comma separated": "tags, comma separated",
  "sheet picture": "sheet picture",
  "character file": "character file",
  "chi saw": "chi saw",
  "use as picture": "use as picture",
  "add pic": "add pic",
  "drop pic": "drop pic",
  "merge": "merge",
  "merge into": "merge into",
  "pick the same character under another name. its pictures and anything this sheet is missing move here, and imports will update this sheet from then on.": "pick the same character under anither name. its pictures and anything this sheet is missing move here, and imports will update this sheet from then on.",
  "Calendar": "Calendar",
  "Maps": "Maps",
  "near me": "near me",
  "maps needs a google key": "maps needs a google key",
  "in console.cloud.google.com make a project and turn on billing": "in console.cloud.google.com make a project and turn on billing",
  "turn on": "turn on",
  "and": "and",
  "make an api key under credentials, and limit it to those three apis": "make an api key under credentials, and limit it tae those three apis",
  "paste it in setup, keys, google maps. or put it on the server as GOOGLE_MAPS_API_KEY": "paste it in setup, keys, google maps. or put it on the server as GOOGLE_MAPS_API_KEY",
  "open setup": "open setup",
  "search this area": "search this area",
  "route here": "route here",
  "route from": "route from",
  "remove": "remove",
  "nearby": "nearby",
  "route": "route",
  "best rated": "best rated",
  "most reviews": "maist reviews",
  "closest": "closest",
  "parking first": "parking first",
  "add where you start and where you're going. places from nearby can go in with their route button": "add whaur ye start and whaur ye're going. places from nearby can go in wi' their route button",
  "from here": "from here",
  "home": "hame",
  "best order for the middle stops": "best order for the middle stops",
  "plan route": "plan route",
  "time": "time",
  "distance": "distance",
  "stops": "stops",
  "pins": "pins",
  "tap drop a pin, then tap the map where it goes": "tap drop a pin, then tap the map whaur it goes",
  "pin where i am": "pin whaur i am",
  "places": "places",
  "star a place from nearby to keep it here": "star a place from nearby tae keep it here",
  "routes": "routes",
  "plan a route and save it to keep it here": "plan a route and save it tae keep it here",
  "only you see these unless you switch places and routes on for someone in sharing": "only ye see these unless ye switch places and routes on for somebody in sharing",
  "tape": "tape",
  "Scans": "Scans",
  "photo": "photo",
  "scan": "scan",
  "on this pc": "on this pc",
  "upload all": "upload all",
  "scans the brother left in the inbox folder that the web cannot see yet": "scans the brother left in the inbox folder that the web cannae see yet",
  "no scans yet. scan on the pc, or snap a photo of a sketch": "nae scans yet. scan on the pc, or snap a photo o' a sketch",
  "Doodles": "Doodles",
  "paste": "paste",
  "no doodles yet. paste one, or add pictures from your phone": "nae doodles yet. paste one, or add pictures from yer phone",
  "doodle": "doodle",
  "title": "title",
  "drawn by": "drawn by",
  "day": "day",
  "characters in it": "characters in it",
  "undo mine": "undo mine",
  "newer": "newer",
  "older": "aulder",
  "Server": "Server",
  "reload caddy": "reload caddy",
  "memory": "memory",
  "load": "load",
  "bots up": "bots up",
  "Logs": "Logs",
  "nothing happened yet, it shows up here live": "naething happened yet, it shows up here live",
  "billing": "billing",
  "month": "month",
  "tags": "tags",
  "key": "key",
  "tagging": "tagging",
  "budget": "budget",
  "batch": "batch",
  "by model": "by model",
  "by person": "by person",
  "estimates from the token counts claude sends back. billing has the real bill": "estimates from the token counts claude sends back. billing has the real bill",
  "People": "People",
  "let in": "let in",
  "their chi": "their chi",
  "yours": "yers",
  "everyone talks to chi on your claude key. they never see it, their chats and memory stay their own, and their share of the bill is counted here": "everyone talks tae chi on yer claude key. they never see it, their chats and memory stay their ain, and their share o' the bill is counted here",
  "let someone in": "let somebody in",
  "they sign in with discord. if they try before you add them, the page shows them their id to send you": "they sign in wi' discord. if they try afore ye add them, the page shows them their id tae send ye",
  "only you": "jist yersel",
  "Sharing": "Sharing",
  "pick what each person can see. they can only read it, never change it. it shows up next to their own notes, pings and the rest, and their chi can read it too": "pick whit each person can see. they can only read it, never change it. it shows up next tae their ain notes, pings and the rest, and their chi can read it too",
  "shared with you": "shared wi' ye",
  "nobody shares anything with you yet": "naebody shares anything wi' ye yet",
  "Setup": "Setup",
  "assistant": "assistant",
  "anthropic api key": "anthropic api key",
  "chat model": "chat model",
  "ref tagging model": "ref tagging model",
  "monthly tagging budget, usd": "monthly tagging budget, usd",
  "tagging pauses once the month's estimate passes the budget. 0 means no cap. claude-haiku-4-5 tags cheaper": "tagging pauses once the month's estimate passes the budget. 0 means nae cap. claude-haiku-4-5 tags cheaper",
  "currency": "currency",
  "yours only. the sign shown on comms, money stats and the budget. auto reads it from what you type on commissions. it saves as soon as you pick": "yers only. the sign shown on comms, money stats and the budget. auto reads it from whit ye type on commissions. it saves as soon as ye pick",
  "log into the plane tab, then connect": "log into the plane tab, then connect",
  "open plane, make an api token in profile settings, paste it here": "open plane, make an api token in profile settings, paste it here",
  "connect plane": "connect plane",
  "workspace slug": "workspace slug",
  "api key": "api key",
  "load boards": "load boards",
  "chix bot": "chix bot",
  "api url": "api url",
  "your discord user id": "yer discord user id",
  "browser key, optional": "browser key, optional",
  "the api key searches places and plans routes from the server. the map itself loads with the browser key if there is one, otherwise the api key. GOOGLE_MAPS_API_KEY on the server wins over this": "the api key searches places and plans routes from the server. the map itself loads wi' the browser key if there is one, otherwise the api key. GOOGLE_MAPS_API_KEY on the server wins over this",
  "server": "server",
  "bots folder": "bots folder",
  "sudo password": "sudo password",
  "ssh host": "ssh host",
  "ssh user": "ssh user",
  "ssh key file": "ssh key file",
  "browser extension": "browser extension",
  "paste this into the extension options as the cloud token. it's yours, so saves land as you": "paste this into the extension options as the cloud token. it's yers, so saves land as ye",
  "chrome: unzip over the old folder and hit reload in chrome://extensions. firefox: open the file in firefox and allow it, it updates itself after that": "chrome: unzip over the auld folder and hit reload in chrome://extensions. firefox: open the file in firefox and allow it, it updates itself efter that",
  "your extension token": "yer extension token",
  "copy": "copy",
  "new token": "new token",
  "links": "links",
  "one per line as name | url. they open inside the desk app, or in a new tab on the web": "one per line as name | url. they open inside the desk app, or in a new tab on the web",
  "desk": "desk",
  "cloud url": "cloud url",
  "cloud token": "cloud token",
  "chrome extension token": "chrome extension token",
  "brother scan folder": "brother scan folder",
  "start with windows": "start wi' windows",
  "security": "security",
  "signs out every phone, tablet and browser that is logged in, including this one. use it if a device was lost or you think someone got in": "signs oot every phone, tablet and browser that is logged in, including this one. use it if a device was lost or ye think somebody got in",
  "log out everywhere": "log oot everywhere",
  "pick a look": "pick a look",
  "background pattern": "background pattern",
  "film grain and fog": "film grain and fog",
  "calm motion": "calm motion",
  "retry": "retry",
  "toss": "toss",
  "logs": "logs",
  "paid on": "paid on",
  "undo": "undo",
  "setup token": "setup token",
  "talk to chi": "blether wi' chi",
  "jot into inbox": "jot into inbox",
  "whose budget": "wha's budget",
  "what kind": "whit kind",
  "what it is": "whit it is",
  "ask chi…": "ask chi…",
  "ask": "ask",
  "refresh": "refresh",
  "find a task": "find a task",
  "just type, it saves itself": "jist type, it saves itself",
  "search notes": "search notes",
  "back": "back",
  "print": "print",
  "# heading\n\nmarkdown works, autosave is on": "# heading\n\nmarkdown works, autosave is on",
  "search refs, tags, characters": "search refs, tags, characters",
  "tile size": "tile size",
  "add pictures": "add pictures",
  "sort the feed": "sort the feed",
  "what you want to remember about this": "whit ye want tae remember aboot this",
  "re-index": "re-index",
  "open post": "open post",
  "message chi": "message chi",
  "send": "send",
  "a sketch a day…": "a sketch a day…",
  "how often": "hoo often",
  "how many": "hoo mony",
  "note, optional": "note, optional",
  "nudge me about…": "nudge me aboot…",
  "kind": "kind",
  "set the time": "set the time",
  "minutes, like 40 or 1h30": "minutes, like 40 or 1h30",
  "reset": "reset",
  "another tip": "anither tip",
  "pick a colour": "pick a colour",
  "name, like sitting nsfw": "name, like sitting nsfw",
  "piece": "piece",
  "client (for the money stats)": "client (for the money stats)",
  "amount": "amount",
  "due": "due",
  "what they want drawn": "whit they want drawn",
  "previous month": "previous month",
  "next month": "next month",
  "what is it": "whit is it",
  "owed": "owed",
  "category": "category",
  "only refs matching… (optional)": "only refs matching… (optional)",
  "add the characters from zirk.eu/oc": "add the characters from zirk.eu/oc",
  "add the characters from the discord character channel": "add the characters from the discord character channel",
  "chi looks at character pictures and writes tags and a line about each, so she picks better characters and refs": "chi looks at character pictures and writes tags and a line aboot each, so she picks better characters and refs",
  "search name, race, likes, fetishes…": "search name, race, likes, fetishes…",
  "search characters…": "search characters…",
  "reload": "reload",
  "add an event": "add an event",
  "map": "map",
  "name it: studio, mum's, good parking": "name it: studio, maw's, braw parking",
  "a note, optional": "a note, optional",
  "colour": "colour",
  "sushi, art supplies, an address": "sushi, art supplies, an address",
  "how far": "hoo far",
  "add a stop: address, postcode or place": "add a stop: address, postcode or place",
  "add stop": "add stop",
  "download": "download",
  "add the picture on your clipboard, or press ctrl+v": "add the picture on yer clipboard, or press ctrl+v",
  "search title, artist, character, tag…": "search title, artist, character, tag…",
  "untitled": "untitled",
  "type a name to add a character": "type a name tae add a character",
  "count a fap": "count a fap",
  "console.anthropic.com, api keys": "console.anthropic.com, api keys",
  "the part after the domain": "the part efter the domain",
  "maps javascript, places (new) and routes": "maps javascript, places (new) and routes",
  "only if the map should load with its own key": "only if the map should load wi' its ain key",
  "find a tool or place": "find a tool or place",
  "what needs doing?": "whit needs doing?",
  "optional notes": "optional notes",
  "index": "index",
  "mark done": "mark done",
  "status": "status",
  "link a task": "link a task",
  "find a plane or chix task": "find a plane or chix task",
  "take back the last one": "take back the last one",
  "take out": "take oot",
  "tasks": "tasks",
  "Today": "The day",
  "References": "References",
  "describe": "describe",
  "Ask ChiX": "Ask ChiX",
  "gesture": "gesture",
  "Gesture drawing": "Gesture drawing",
  "Session timer": "Session timer",
  "palette": "palette",
  "Commissions": "Commissions",
  "maps": "maps",
  "Calculator": "Calculator",
  "doodles": "doodles",
  "scans": "scans",
  "Claude usage": "Claude usage",
  "people": "people",
  "share": "share",
  "setup": "setup",
  "keys": "keys",
  "themes": "themes",
  "studio": "studio",
  "system": "system",
  "Home": "Hame",
  "Studio": "Studio",
  "Practice": "Practice",
  "Ledger": "Ledger",
  "Library": "Library",
  "Core": "Core",
  "language": "language",
  "yours only. the app's words and chi's replies follow it. it saves as soon as you pick": "yers only. the app's words and chi's replies follow it. it saves as soon as ye pick",
  "Quick note": "Quick note",
  "Reminders": "Reminders",
  "Ubuntu helpers": "Ubuntu helpers",
  "Quit": "Awa wi' it",
  "open {name}": "open {name}",
  "sort": "sort",
  "this one is mine": "this one is mine",
  "reverse the order": "reverse the order",
  "filter": "filter",
  "{name} can sign in now. they start with chi, notes, pings, routines and goals": "{name} can sign in noo. they start wi' chi, notes, pings, routines and goals"
};
